'use strict';

/* Controllers */

app.controller('TicketedEventLandingPageController', ['$scope', '$rootScope', 'TicketedEvent', 'Popup', '$location', 'Helper', 'Preloader', '$timeout', '$routeParams',
    function ($scope, $rootScope, TicketedEvent, Popup, $location, Helper, Preloader, $timeout, $routeParams) {

    	// set application flow
    	$rootScope.globals.flow = 'ticketing';

        Preloader.open();

        $scope.slug = $routeParams.event_name || null;
        $scope.currency_symbol = 'S$';

        TicketedEvent.get($scope.slug, function(resp){

            Preloader.close();

            if (resp.data.success) {
                // save event to root globals
                $rootScope.globals.ticketedEvent = resp.data;
                $rootScope.globals.ticketedEvent.event.slug = $scope.slug;

                // Get facebook meta
                $rootScope.facebookMeta = Helper.getFacebookMetaData($rootScope.globals.ticketedEvent.event);
                $rootScope.redirectUrl = Helper.getRedirectUrl();
                $rootScope.waave_url = Helper.getWaaveUrl();

                // save data to storage
                //Helper.updateLocalStorageWithGlobalVariable();
            } else if (resp.data.httpCode == 404) {
                Popup.error('Event does not exist.', function () {
                    window.location.href = 'http://getwaave.com';
                });
            } else {
                Popup.error('Something went wrong :(', function () {
                    $location.path('/');
                });
            }
        });

        // hide preloader after 3 seconds
        $timeout(function(){
            Preloader.close();
        }, 3000);

    }]);
